import { ActionType } from 'typesafe-actions'

import { itemPriceHistoryActions, itemPriceHistoryActionType } from './actions'
import {
  ItemPriceHistory,
  ItemPriceHistoryPagination,
} from './item-price-histories'

export interface ItemPriceHistoryState {
  readonly histories: ItemPriceHistory[]
  readonly pagination: ItemPriceHistoryPagination
  readonly isLoading: boolean
  readonly error: Error | null
}

const initialState: ItemPriceHistoryState = {
  histories: [],
  pagination: {
    page: 1,
    per: 20,
    total: 0,
  },
  isLoading: false,
  error: null,
}

export const itemPriceHistoryReducer = (
  state: ItemPriceHistoryState = initialState,
  action: ActionType<typeof itemPriceHistoryActions>
): ItemPriceHistoryState => {
  switch (action.type) {
    case itemPriceHistoryActionType.FETCH_ITEM_PRICE_HISTORIES:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case itemPriceHistoryActionType.FETCH_ITEM_PRICE_HISTORIES_SUCCEEDED:
      return {
        ...state,
        histories: action.payload.histories,
        pagination: action.payload.pagination,
        isLoading: false,
        error: null,
      }
    case itemPriceHistoryActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}
